import { render } from "./KubernetesService.vue?vue&type=template&id=47b26464"
import script from "./KubernetesService.vue?vue&type=script&lang=js"
export * from "./KubernetesService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__